
export enum E015UserOPEEnum {
  PutE015User = 'putE015User',
  GetE015Users = 'getE015Users',
  DelE015User = 'delE015User'
}
